export class CompilableBase {
    getOption() {
        return this._option;
    }
    constructor(option) {
        this._option = option, this.getCompiler = this._option.getCompiler;
    }
    getStage() {
        var _a;
        return null === (_a = this.getCompiler()) || void 0 === _a ? void 0 : _a.getStage();
    }
    release() {
        this._option = null, this.getCompiler = null;
    }
}
//# sourceMappingURL=compilable-base.js.map